import React from "react";

import { SearchRounded } from "@mui/icons-material";
import { Box, ButtonBase, CircularProgress } from "@mui/material";

import useModal from "../../../../../config/context/modalContext";
import { AuthService } from "../../../../../config/services/AuthService";
import { GreyPallet } from "../../../../../config/styles";
import { Dev } from "../../../../../config/util/consoleUtil";

import ChipMain from "../../../../../components/InputMain/ChipMain";
import TextMain from "../../../../../components/InputMain/TextMain";
import MainModalSimple from "../../../../../components/MainModalSimple";
import MainSubmit from "../../../../../components/MainSubmit";
import MainText from "../../../../../components/MainText";

import { UserInfoType } from "../../../../../types/database";

type SearchUserFieldProps = {
  onUserClick: (user: UserInfoType) => void;
};

export default function SearchUserField({ onUserClick }: SearchUserFieldProps) {
  const { pushAlert } = useModal();

  const UserList = AuthService.List();

  const [openModalSearchUser, setOpenModalSearchUser] = React.useState(false);

  const [searchField, setSearchField] = React.useState("");
  const [userFieldName, setUserFieldName] = React.useState<"id" | "email" | "name">("email");

  const handleSearchUser = async () => {
    try {
      if (!searchField) throw Error("O campo de busca não pode ser vazio");
      await UserList.runRequest(userFieldName, searchField);

      setOpenModalSearchUser(true);
    } catch (error) {
      console.log(...new Dev("handleSearchUser", error).Error());
      pushAlert({ type: "error", message: "Erro ao buscar usuários. " + (error as Error).message });
    }
  };

  return (
    <>
      {openModalSearchUser && (
        <MainModalSimple
          isClosable
          title="Usuários Encontrados"
          onClose={() => setOpenModalSearchUser(false)}
        >
          <Box>
            {UserList.items?.length ? (
              UserList.items.map((item) => (
                <ButtonBase
                  key={item.id}
                  onClick={() => onUserClick(item)}
                  style={{
                    border: `3px solid ${GreyPallet.Light}`,
                    borderRadius: 15,
                    width: "100%",
                    overflow: "hidden",
                    marginBottom: 20,
                  }}
                >
                  <Box
                    style={{
                      textAlign: "start",
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                    px={2}
                    py={1}
                  >
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <MainText color="black" size="subtitle">
                        {item?.name || "-"}
                      </MainText>
                      <MainText color="regular" size="caption">
                        {item?.email || "-"}
                      </MainText>
                    </Box>
                  </Box>
                </ButtonBase>
              ))
            ) : (
              <MainText size="caption" color="regular">
                Nenhum usuário encontrado...
              </MainText>
            )}
          </Box>
        </MainModalSimple>
      )}

      <MainSubmit onSubmit={handleSearchUser}>
        <TextMain
          name="Buscar usuário"
          value={searchField}
          inputType={userFieldName === "email" ? "email" : "text"}
          onChange={setSearchField}
          textColor={"regular"}
          adornmentIcon={
            UserList.isLoading ? (
              <CircularProgress style={{ color: GreyPallet.Regular, width: 26, height: 26 }} />
            ) : (
              <SearchRounded />
            )
          }
          adornmentClick={handleSearchUser}
        />
      </MainSubmit>

      <Box mb={2} gap={1} display={"flex"}>
        <ChipMain
          options={[
            { name: "Email", value: "email" },
            { name: "ID", value: "id" },
            { name: "Nome", value: "name" },
          ]}
          onChange={(value) => setUserFieldName(value as "email" | "id" | "name")}
          value={userFieldName}
        />
      </Box>
    </>
  );
}
